import { ASSIGN_ACTION_NAME } from './constants';
export function assign(fn) {
  return (context, event) => {
    return {
      type: ASSIGN_ACTION_NAME,
      data: fn(context, event)
    };
  };
}